import removeAccents from "remove-accents";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Spaces, dots, dashes, brackets and a leading "+" are what people type around a phone number.
const PHONE_CHARACTERS_PATTERN = /^\+?[\d\s.\-()]+$/;
const PHONE_MIN_DIGITS = 9;

export const NAME_MAX_LENGTH = 100;

/** Same split as the api: a contact with an "@" is an e-mail, anything else a phone number. */
export const isValidPoolContact = (contact) => {
    const value = String(contact ?? "").trim();
    if (!value) return false;
    if (value.includes("@")) return EMAIL_PATTERN.test(value);
    return PHONE_CHARACTERS_PATTERN.test(value) && value.replace(/\D/g, "").length >= PHONE_MIN_DIGITS;
};

export const isValidPoolName = (name) => {
    const value = String(name ?? "").trim();
    return value.length > 0 && value.length <= NAME_MAX_LENGTH;
};

/** "Antilles Logistique" → "vivier-antilleslogistique.png" */
export const toInviteQrCodeFileName = (companyName) => {
    const slug = removeAccents(String(companyName ?? ""))
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    return `vivier-${slug || "entreprise"}.png`;
};
